import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import SubString from 'add-ellipsis';
import RaisedButton from 'material-ui/RaisedButton';
import { change, Field, reduxForm } from 'redux-form';

import { PatientSkillAcqActiveTargetist, getPatientSkillAcqTaskAnalysislist, selectedProgramForTargetAction } from './actions/targetsAction';
import { SetProgramIDsForSkillAcqTargetAction } from '../programs/actions/programsActions';
import { getPatientPromptCodeListToCollectData } from '../../../../../DataCollection/SetUp/promptCodes/actions/PromptCodeActions';
import SortingCustom from '../../../../../../../../components/SortingCustom';
import DTTModal from './DttModal';
import TaskAnalysisModal from './TaskAnalysisModal';
import TodaysDTTDataModal from './TodaysDTTDataModal';
import TodaysTADataModal from './TodaysTADataModal';
import Tooltip from '../../../../../../../../components/Tooltip';
import { renderAutoCompleteScheduling } from '../../../../../../../../components/reduxFields';



class SkillAcqActiveTargets extends Component {

    constructor(props) {
        super(props);
        this.state = {
            creadteDate: props.creadteDate,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            statusId: null,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysDTTDataModal: false,
            openTodaysTADataModal: false,
            targetObj: {},
            filteredSteps: [],
            selectedActiveProgramIds: props.ProgramIdsForTargetListingApplicationState,
        }

        this.filter = {
            sort_Column: '',
            sort_Order: '',
            searchText: '',
        };
        this.handleNewRequest = this.handleNewRequest.bind(this);
    }

    componentWillMount = () => {
        this.loadData();
        this.loadPromtCodes();
        this.props.getPatientSkillAcqTaskAnalysislist(this.state.patientId);
        this.props.selectedProgramForTargetAction(this.state.patientId, this.props.ProgramIds);
    }

    loadData = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_Order || '',
            contain_filters: {
                patientId: this.state.patientId,
                skillsAcquisitionProgramIds: this.state.selectedActiveProgramIds,
                searchText: this.filter.searchText || null
            },
            pageNumber: page_number || 1,
        };

        this.props.PatientSkillAcqActiveTargetist(searchObj)
    }

    handleNewRequest(input, value) {
        input.onChange(value);
        if (value.length > 0) {
            this.setState({
                selectedActiveProgramIds: value
            }, () => {
                this.props.SetProgramIDsForSkillAcqTargetAction(value),
                this.loadData()
            })
        }
        else {
            this.setState({
                selectedActiveProgramIds: this.props.ProgramIds
            }, () => {
                    this.props.SetProgramIDsForSkillAcqTargetAction(this.props.ProgramIds)
                    this.loadData()
            })
        }
    }

    loadPromtCodes = () => {
        let searchObj = {
            contain_filters: { patientId: this.state.patientId || null },
            pageNumber: 1,
        };
        this.props.getPatientPromptCodeListToCollectData(searchObj, false);
    }

    handleViewClick = (Obj) => {
        let filteredSteps = [];
        if (this.props.patientSkillAcqTaskAnalysisList !== null && this.props.patientSkillAcqTaskAnalysisList.data.PatientSkillsAcqTaskAnalysis.length > 0) {
            let data = this.props.patientSkillAcqTaskAnalysisList.data.PatientSkillsAcqTaskAnalysis
            filteredSteps = data.filter((obj, index) => {
                return obj.skillsAcquisitionTargetId === Obj.skillsAcquisitionTargetId;
            })
        }
        if (Obj.targetType.toUpperCase() === "DTT") {
            this.setState({
                openDttModal: true,
                openTaskAnalysisModal: false,
                skillsAcquisitionProgramId: Obj.skillsAcquisitionProgramId,
                targetObj: Obj,
                statusId: Obj.statusId
            })
        }
        else if (Obj.targetType.toUpperCase() === "TASK ANALYSIS") {
            this.setState({
                openDttModal: false,
                openTaskAnalysisModal: true,
                skillsAcquisitionProgramId: Obj.skillsAcquisitionProgramId,
                targetObj: Obj,
                filteredSteps: filteredSteps,
                statusId: Obj.statusId
            })
        } else {
            return;
        }
    }

    handleClose = () => {
        this.setState({
            openTodaysDTTDataModal: false,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysTADataModal: false
        })
    }

    handleTodaysDTTData = () => {
        this.setState({
            openTodaysDTTDataModal: true,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysTADataModal: false,
        });
    }

    setSortColumn = (col_name, col_order) => {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;
            this.loadData();
        }
    }

    handleTodaysTAData = () => {
        this.setState({
            openTodaysDTTDataModal: false,
            openDttModal: false,
            openTaskAnalysisModal: false,
            openTodaysTADataModal: true,
        });
    }

    handleReset = () => {
        this.setState({
            selectedActiveProgramIds: this.props.ProgramIds
        }, () => {
            this.loadData(),
            this.props.dispatch(change("SkillAcqActiveTargetsForm", "ProgramNameForSession", null ))
        })
    }

    renderData = (patientSkillAcqActiveTargetList) => {
        patientSkillAcqActiveTargetList = patientSkillAcqActiveTargetList || [];
        if (!patientSkillAcqActiveTargetList.length) {
            return (
                <tr>
                    <td colSpan="5">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return patientSkillAcqActiveTargetList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>
                        {Obj.programName && Obj.programName.length > 0 ?
                            <Tooltip Description={Obj.programName} />
                            : null}
                        {Obj.programName != null && Obj.programName.length > 25 ? SubString(Obj.programName, 25) : Obj.programName != null ? Obj.programName : 'N/A'}
                    </td>
                    <td>{Obj.targetName}</td>
                    {/* <td>{Obj.programName}</td> */}
                    <td>{Obj.status}</td>
                    <td>{Obj.targetType}</td>
                    <td>
                        <button onClick={() => this.handleViewClick(Obj)} type="button" title="Collect Data" className="tbactionbtn bluefont"><i className="fa fa-file-text" aria-hidden="true"></i></button>
                    </td>
                </tr>
            )
        })
    }

    renderSkillAcqActiveTargetsTabs = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientSkillAcqActiveTargetList } = this.props;
        let PatientSkillAcqActiveTargetList = (patientSkillAcqActiveTargetList && patientSkillAcqActiveTargetList.data) || [];
        return (
            <div className="readmin-panel">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="30%"><SortingCustom noSort={!PatientSkillAcqActiveTargetList.length} setSortColumn={this.setSortColumn} columnName='programName' displayName='Program Name' /></th>
                                            <th width="40%"><SortingCustom noSort={!PatientSkillAcqActiveTargetList.length} setSortColumn={this.setSortColumn} columnName='targetName' displayName='Target Name' /></th>
                                            <th width="15%">Status</th>
                                            <th width="10%">Target Type</th>
                                            <th width="5%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientSkillAcqActiveTargetList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    render() {
        return (
            <div>
               <div className="row">
                    <div className="col-sm-3 mt-10">
                        <RaisedButton
                            //style={{ marginTop: '10px', marginLeft: '22px', float: 'left' }}
                            label="Back"
                            primary={true}
                            onTouchTap={this.props.handleBack} />
                    </div>
                    <div className="col-sm-6 mt-20">
                    {this.props.selectedprogramIds !== null && <Field
                            name="ProgramNameForSession"
                            label="program"
                            handleNewRequest={this.handleNewRequest}
                            options={this.props.selectedprogramIds.data}
                            component={renderAutoCompleteScheduling}
                            fullWidth={true}
                        />}
                    </div>
                    <div className="col-sm-3 mt-10">
                        <RaisedButton
                            className="grey_btn"
                            //style={{ marginTop: '10px', marginRight: '22px', float: 'left' }}
                            label="Reset"
                            primary={true}
                            onTouchTap={() => this.handleReset()} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter">                        
                        <RaisedButton
                            style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                            label="Today's DTT Data"
                            primary={true}
                            onTouchTap={() => this.handleTodaysDTTData()} />
                                   
                        <RaisedButton
                            style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                            label="Today's TA Data"
                            primary={true}
                            onTouchTap={() => this.handleTodaysTAData()} />
                    </div>
                </div>
                {this.renderSkillAcqActiveTargetsTabs()}
                {
                    this.state.openTodaysDTTDataModal === true &&
                    <TodaysDTTDataModal
                        patientId={this.state.patientId}
                        uuid={this.props.uuid}
                        targetObj={this.state.targetObj}
                        creadteDate={this.state.creadteDate}
                        closeDialog={() => this.handleClose()}
                    />
                }
                {this.state.openDttModal === true &&
                    <DTTModal
                        patientId={this.state.patientId}
                        uuid={this.props.uuid}
                        statusId={this.state.statusId}
                        creadteDate={this.state.creadteDate}
                        closeDialog={() => this.handleClose()}
                        promptCodeListData={this.props.promptCodeListData}
                        targetObj={this.state.targetObj}
                    />
                }
                {this.state.openTaskAnalysisModal === true &&
                    <TaskAnalysisModal
                        patientId={this.state.patientId}
                        uuid={this.props.uuid}
                        statusId={this.state.statusId}
                        creadteDate={this.state.creadteDate}
                        targetObj={this.state.targetObj}
                        filteredSteps={this.state.filteredSteps}
                        promptCodeListData={this.props.promptCodeListData}
                        closeDialog={() => this.handleClose()} />
                }
                {
                    this.state.openTodaysTADataModal === true &&
                    <TodaysTADataModal 
                    patientId={this.state.patientId}
                    uuid={this.props.uuid}
                    targetObj={this.state.targetObj}
                    creadteDate={this.state.creadteDate}
                    closeDialog={() => this.handleClose()}
                    />
                }
            </div>
        )
    }
}

SkillAcqActiveTargets = reduxForm({
    form: 'SkillAcqActiveTargetsForm',
})(SkillAcqActiveTargets);

function mapStateToProps(state) {
    return {
        loading: state.patientSkillAcqActiveTarget.loading,
        patientSkillAcqActiveTargetList: state.patientSkillAcqActiveTarget.patientSkillAcqActiveTargetList,
        promptCodeListData: state.patient_prompt_code.promptCodeList,
        patientSkillAcqTaskAnalysisList: state.patientSkillAcqActiveTarget.patientSkillAcqTaskAnalysisList,
        uuid: state.patientSkillAcqActiveProgram.uuid,
        ProgramIds: state.patientSkillAcqActiveProgram.ProgramIds,
        selectedprogramIds: state.patientSkillAcqActiveTarget.selectedProgramForTarget,
        ProgramIdsForTargetListingApplicationState: state.patientSkillAcqActiveProgram.ProgramIdsForTargetListingApplicationState
    }
}

export default connect(mapStateToProps, { PatientSkillAcqActiveTargetist, getPatientPromptCodeListToCollectData, getPatientSkillAcqTaskAnalysislist, selectedProgramForTargetAction, SetProgramIDsForSkillAcqTargetAction })(SkillAcqActiveTargets)



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/target.js